import { Divider } from '@mui/material';
import { styled } from '@mui/system';

const WhiteDivider = styled(Divider)(({ theme }: any) => ({
  width: '100%',
  '&::before, &::after': {
    borderTop: `thin solid ${(theme.palette as any).white?.light || theme.palette.divider}`,
  },
}));

export default WhiteDivider;

